import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import {PatientsService} from "../../_services/patients.service";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {CrmpointsService} from "../../_services/crmpoints.service";

@Component({
  selector: 'app-add-user-crm-points',
  templateUrl: './add-user-crm-points.component.html',
  styleUrls: ['./add-user-crm-points.component.css']
})
export class AddUserCrmPointsComponent implements OnInit {

  addCrmPointForm: FormGroup;
  submitted = false;
  userid: any;
  patients: any;
  returnUrl: string;
  userdetaild: string;

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService,  private patientsService: PatientsService, private spinnerService: Ng4LoadingSpinnerService, private crmpointsservice: CrmpointsService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.userid = this.route.snapshot.params.id;

    this.addCrmPointForm = this.formBuilder.group({
      type: ['', [Validators.required]],
      user_email: [{value: '', disabled: true}, [Validators.required]],
      points: ['', [Validators.required]],
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getPatientById();
  }


  getPatientById() {
    this.patientsService.getPatientById(this.userid)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.patients = data.patientList;

            this.addCrmPointForm.setValue({
              type: '',
              user_email: this.patients.patientid.users_email,
              points: '1'
            })

          } else {
            console.log('Patients', data.ResponseMessage);
          }
        },
        error => {
          console.log('Patients', error.error.ResponseMessage);
        });
  }

  get f() { return this.addCrmPointForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addCrmPointForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      type: this.addCrmPointForm.controls.type.value,
      user_id: this.userid,
      user_email: this.addCrmPointForm.controls.user_email.value,
      points: this.addCrmPointForm.controls.points.value,
    };

    this.addCrmPoint(addPayload);

  }

  addCrmPoint(payload) {

    this.crmpointsservice.addCrmPoints(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            console.log('CRM Point',data.ResponseMessage);
            this.router.navigate([`/crm-points/${this.userid}`]);
          } else {
            this.toaster.showError('CRM Point',data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('CRM Point',error.error.ResponseMessage);

        });
  }



}
